import * as Header from '../components/header';
import { Browser } from '../utils/browsercheck';
import { onDomReady } from '../utils/dom';
import * as ScrollUtil from '../utils/scrolling';

function deleteEmptyPTags() {
    // Lösche leere p Tags mit Leerzeichen
    for (const p of document.querySelectorAll('#main p')) {
        if (p.innerHTML.replace(/\s| |&nbsp;/g, '') === '') {
            p.remove();
        }
    }
}

function addExternalLinkClass() {
    const not = ':not(.social-link)';

    /** @type {NodeListOf<HTMLAnchorElement>} */
    const links = document.querySelectorAll(`a[href^="http://"]${not}, a[href^="https://"]${not}`);

    for (const a of links) {
        if (!a.hostname.endsWith(location.hostname) && !a.parentElement.classList.contains('image_container')) {
            a.classList.add('external-link');
        }
    }
}

function setCustomProperties() {
    const footer = document.getElementById('footer');

    document.body.style.setProperty('--header-height', `${Header.getHeight(true)}px`);
}

function setTouchDeviceClass() {
    if (Browser.isTouchDevice()) {
        document.documentElement.classList.add('touch');
    }
}

function fullHeight() {
    for (const img of document.querySelectorAll('.full-height img')) {
        img.style.height = `calc(100vh - ${Header.getHeight()}px)`;
    }
}

function scrollToAnchor() {
    for (const a of document.querySelectorAll('a[href*="#"]')) {
        a.addEventListener('click', function (e) {
            ScrollUtil.scrollToAnchor(e, this);
        });
    }
}

function addLoadingClassToImages() {
    /** @type {NodeListOf<HTMLImageElement>} */
    const images = document.querySelectorAll('img:not([href$=".svg"]');

    images.forEach((img) => {
        if (img.complete && img.naturalHeight !== 0) {
            return;
        }

        img.onload = () => {
            img.classList.remove('loading');
        };

        if (img.hasAttribute('width')) {
            img.style.setProperty('--loading-width', `${img.getAttribute('width')}px`);
        }

        img.classList.add('loading');
    });

    // Sometimes onload is not fired, so we add a fallback
    window.addEventListener('load', () => {
        images.forEach((img) => img.classList.remove('loading'));
    });
}

function addFocusTrap() {
    const overlays = document.querySelectorAll('.focus-trap, .contao-cookiebar');
    const focusableElementsMap = new Map();

    const getFocusableElements = (overlay) => {
        // Focus trap for the overlay
        let focusableElements = overlay.querySelectorAll('button, [href], input, textarea, select');

        focusableElements = Array.from(focusableElements).filter((el) => {
            return el.offsetParent !== null && !el.disabled && !el.hasAttribute('aria-hidden');
        });

        if (focusableElements.length === 0) return null;

        return focusableElements;
    };

    for (const overlay of overlays) {
        const initTrap = (e) => {
            const focusableElements = focusableElementsMap.get(overlay);
            if (!focusableElements) return;

            const firstFocusableElement = focusableElements[0];
            const lastFocusableElement = focusableElements[focusableElements.length - 1];

            if (e.key === 'Tab') {
                if (e.shiftKey) {
                    if (document.activeElement === firstFocusableElement) {
                        lastFocusableElement.focus();
                        e.preventDefault();
                    }
                } else {
                    if (document.activeElement === lastFocusableElement) {
                        firstFocusableElement.focus();
                        e.preventDefault();
                    }
                }
            }
        };

        focusableElementsMap.set(overlay, getFocusableElements(overlay));
        overlay.addEventListener('keydown', initTrap);

        const toggleBtns = overlay.querySelectorAll('[data-toggle-group]');

        for (const toggleBtn of toggleBtns) {
            toggleBtn.addEventListener('click', () => {
                overlay.removeEventListener('keydown', initTrap);

                focusableElementsMap.set(overlay, getFocusableElements(overlay));
                overlay.addEventListener('keydown', initTrap);
            });
        }
    }
}

/**
 * Seite einblenden wenn sie fertig geladen ist
 */
function fadeInSite() {
    const loader = document.getElementById('page-loader');

    if (loader) {
        loader.classList.add('hide');
    }

    setTimeout(() => document.documentElement.classList.replace('loading', 'loaded'), 400);
}

onDomReady(() => {
    addLoadingClassToImages();
    addExternalLinkClass();
    deleteEmptyPTags();
    setCustomProperties();
    setTouchDeviceClass();
    fullHeight();
    scrollToAnchor();
    addFocusTrap();
});

window.addEventListener('load', () => {
    fadeInSite();
    setCustomProperties();

    ScrollUtil.scrollToAnchor(null, window.location);
});

window.addEventListener('resize', () => {
    fullHeight();
    setCustomProperties();
});
